import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../../components/loader';

class FiatQuote extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    const { type, testLoading } = this.props;

    if (testLoading) {
      return (
        <div className="cell small-12 medium-10 large-8 panel quote">
          <div className="center-loader">
            <Loader logo />
          </div>
        </div>
      );
    }

    if (type === 'BUY') {
      return (
        <div className="cell small-12 medium-10 large-8 panel quote">
          <div className="quote-head">
            <h4>SALES QUOTE</h4>
            <p>
              QUOTE #0000
              <br />
              Customer / reference number: 012345678
            </p>
          </div>
          <div className="quote-body">
            <div className="grid-x">
              <div className="cell small-6 medium-6 large-6">
                <p>
                  <span className="st">PREPARED BY</span>
                </p>
                <div className="address">
                  <p>Bar9 GmbH</p>
                  <p>Vaultoro Group</p>
                  <p>Ravensberger Str 17A</p>
                  <p>Berlin 10709</p>
                  <p>Germany</p>
                </div>
              </div>
              <div className="cell small-4 medium-4 large-4">
                <p>
                  <span className="st">PREPARED FOR</span>
                </p>
                <div className="address">
                  <p>Customer Name</p>
                  <p>123 Street</p>
                  <p>City, Postcode</p>
                  <p>Country</p>
                </div>
              </div>
              <div className="cell small-2 medium-2 large-2" style={{ textAlign: 'right' }}>
                <p>
                  <span className="st">PREPARED DATE</span>
                  <br />
                  Jun 06, 20XX
                </p>
                <p>
                  <span className="st">EXP. DATE</span>
                  <br />
                  Aug 06, 20XX
                </p>
              </div>
            </div>
            <table className="quote-table">
              <tbody>
                <tr>
                  <th>Item</th>
                  <th>QTY/grams</th>
                  <th>PRICE/gram</th>
                  <th>Total</th>
                </tr>
                <tr>
                  <td>
                    Allocated Gold bullion secured in Vaultoro Brink&apos;s Zurich Switzerland
                  </td>
                  <td>0</td>
                  <td>0</td>
                  <td>0</td>
                </tr>
                <tr>
                  <td>VAT</td>
                  <td />
                  <td>0</td>
                  <td>0</td>
                </tr>
              </tbody>
            </table>
            <div className="grid-x">
              <div className="cell small-6 medium-6 large-6">
                <h4>TOTAL</h4>
              </div>
              <div className="cell small-6 medium-6 large-6" style={{ textAlign: 'right' }}>
                <h4>$1,234.56</h4>
              </div>
            </div>
          </div>
          <div className="quote-foot">
            <div>
              <p>
                <span className="st">
                  Only send funds from a bank account with the same name as your Vaultoro Account.
                </span>
              </p>
              <div>
                <span className="st">Addressee: </span>
                Bar9 GmbH
                <br />
                <span className="st">IBAN: </span>
                DE 17262 182872 8712872 99
                <br />
                <span className="st">BIC: </span>
                8723863
                <br />
                <span className="st">Customer / reference number: </span>
                012345678
              </div>
            </div>
            <div className="button-area">
              <button type="button" className="vlt-button  dark-b">
                <span>
                  Download PDF
                </span>
              </button>
              <button type="button" className="vlt-button">
                <span>
                  Connect
                </span>
              </button>
            </div>
          </div>
        </div>
      );
    }

    if (type === 'SELL') {
      return (
        <div>
          <div>
            <h1>Sales Quote</h1>
            <h2>Quote #0000</h2>
            <h3>Customer / reference number: 012345678</h3>
          </div>
        </div>
      );
    }

    return (null);
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  orders: state.order,
});

export default connect(mapStateToProps)(FiatQuote);
